import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { Cycle } from '@/types/cycle';
import { CycleSet } from '@/types/cycleset';
import KrpTechopsAdminResource from '@/api/resource/KrpTechopsAdminResource';

export default class ConfigResource extends KrpTechopsAdminResource {
  public async getIsProcessingDay(fiId: any, startDateString: string): Promise<any> {
    const url: string = `/api/rcx/config/${fiId}/processing-days/is-processing-day/${startDateString}`;

    const response: AxiosResponse = await this.apiClient.get(url);

    return response.data.data;
  }

  public async loadFiCycleData(fiId: any, numberToFetch: string): Promise<Cycle[]> {
    const url = `/api/rcx/config/${fiId}/cycle/previously-completed/${numberToFetch}`;

    const response: AxiosResponse = await this.apiClient.get(url);

    return response.data.data;
  }

  public async getAllCycles(fiId: any): Promise<Cycle[]> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/config/${fiId}/cycle-set`,
    );

    const result: CycleSet[] = response.data.data;

    const cycles: Cycle[] = [];
    result.forEach((set: CycleSet) => {
      set.cyclesDesc.forEach((cycle: Cycle) => {
        cycles.push(cycle);
      });
    });
    return cycles;
  }
}
